import { Progress } from "@chakra-ui/react";
import React from "react";

interface APProgressBarProps {
  value: number;
}

export default function APProgressBar(props: APProgressBarProps) {
  return (
    <Progress
      value={props.value}
      borderRadius={4}
      sx={{
        background: "#f2f2f2",
        "& [role=progressbar]": { background: "primary" },

      }}
      colorScheme="green"
    />
  );
}
